import capitalize from './Capitalize';
import currency from './Currency';
import percent from './Percent';
import formatDate from './FormatDate';
import formatDateEnglishShort from './FormatDateEnglishShort';
import notificationDateFormatDisplay from './NotificationDateFormatDisplay';
import formatMoney from './FormatMoney';
import fromNow from './FromNow';
import numberToEnglish from './NumberToEnglish';
import valueInLocalCurrency from './ValueInLocalCurrency';
import valueInUSD from './ValueInUSD';
import HighlightText from './HighlightText';
import numberNoTrail from './NumberNoTrail';
import toLength from "./ToLength";
import latLng from "./LatLng";
import yearsAndDays from "./YearsAndDays";
import snakeToPascal from "./SnakeToPascal";
import snakeToTitle from "./SnakeToTitle";
import yesOrNo from "./YesOrNo";
import riskStatus from "./RiskStatus";

/**
 * Register global filters here, use sparingly.
 */

export default {
    install(Vue) {
        Vue.filter('capitalize', capitalize);
        Vue.filter('currency', currency);
        Vue.filter('percent', percent);
        Vue.filter('formatDate', formatDate);
        Vue.filter('formatDateEnglishShort', formatDateEnglishShort);
        Vue.filter('notificationDateFormatDisplay', notificationDateFormatDisplay);
        Vue.filter('formatMoney', formatMoney);
        Vue.filter('fromNow', fromNow);
        Vue.filter('numberToEnglish', numberToEnglish);
        Vue.filter('valueInLocalCurrency', valueInLocalCurrency);
        Vue.filter('valueInUSD', valueInUSD);
        Vue.filter('highlightText', HighlightText);
        Vue.filter('numberNoTrail', numberNoTrail);
        Vue.filter('toLength', toLength);
        Vue.filter('latLng', latLng);
        Vue.filter('yearsAndDays', yearsAndDays);
        Vue.filter('snakeToPascal', snakeToPascal);
        Vue.filter('snakeToTitle', snakeToTitle);
        Vue.filter('yesOrNo', yesOrNo);
        Vue.filter('riskStatus', riskStatus);
    }
}
